import { render } from "./dutycard.vue?vue&type=template&id=760e155c&scoped=true&ts=true"
import script from "./dutycard.vue?vue&type=script&lang=ts"
export * from "./dutycard.vue?vue&type=script&lang=ts"

import "./dutycard.vue?vue&type=style&index=0&id=760e155c&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760e155c"]])

export default __exports__